import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppWidget from './WhatsAppWidget';

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        // Add top padding to account for fixed navbar
        pt: {
          xs: '56px', // Mobile header height
          md: '56px', // Desktop header height
        },
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Navbar />
      <Box sx={{ flex: 1 }}>
        {children}
      </Box>
      <Footer />
      <WhatsAppWidget phoneNumber="07391137185" />
    </Box>
  );
};

export default Layout; 